import { Chip } from "@heroui/react";
import { StarIcon as StarIconSolid } from "@heroicons/react/24/solid";
import { ChipRemoveButton } from "./ChipRemoveButton";

interface FavoriteChipProps {
    label?: string;
    onRemove?: () => void;
}

export const FavoriteChip = ({ label, onRemove }: FavoriteChipProps) => {
    const isRemovable = !!onRemove;
    const text = label ?? (isRemovable ? "Favorites" : "Favorite");
    return (
        <Chip
            size={isRemovable ? "md" : "lg"}
            color="accent"
            variant={isRemovable ? "soft" : undefined}
            className={isRemovable ? "active-filter-chip" : undefined}
        >
            <StarIconSolid className="w-3.5 h-3.5" />
            <Chip.Label>{text}</Chip.Label>
            {onRemove && <ChipRemoveButton label={text} onPress={onRemove} />}
        </Chip>
    );
};
